




















import { Vue, Component, Prop } from 'vue-property-decorator';
import moduleStore from '../store/migu';
import to from 'await-to-js';

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class stepVideoStyle extends Vue {
  @Prop({ default: false }) 
  isSubmiting: boolean;

  loaded = false; // 是否加载完毕
  needCredit = false; // 是否需要判断权益
  
  leftFreeCount = 0; // 剩余免费次数
  rightsCount = 0; // 权益次数
  freeIcon = this.$publicPath + 'images/migu/free_icon.png';
  consumeIcon = this.$publicPath + 'images/migu/consume_icon.png';
  infoIcon = this.$publicPath + 'images/video_editor/instructions_icon.png';
  
  async mounted() {
    if (this.needCredit) {
      this.queryUserRight();
    }
    this.loaded = true;
  }

  async queryUserRight() {
    const [err, res] = await to(this.$http('getRights'));
    if (err || res.code !== 200) {
      this.$toast('获取权益失败');
      return;
    }
    const { status, rightsCount, experienceCount } = res.data.data;
    // 是否鉴权通过 通过：1 不通过：0
    if(!status) {
      // todo --> 未通过鉴权，跳转登录
    }
    this.leftFreeCount = experienceCount;
    this.rightsCount = rightsCount;
  }
  
  doSubmit() {
    // 不需要判断权益
    if(!this.needCredit) {
      this.doCreateSubmit();
      return;
    }
    // 需要判断权益，获取taskId，有剩余次数时直接提交，否则是升级权益
    this.$emit('query-task', this.leftFreeCount || this.rightsCount);
  }
  doCreateSubmit() {
    if (this.isSubmiting) return;
    this.$emit('submit');
  }

  showOrderTip() {
    // todo --> 显示订阅明细
  }
}
